import { PermissionsEnum } from "@/auth/interfaces";
import { ROUTER_PATHS, useCheckPermissions, useLoaders } from "@/shared";
import { useEffect } from "react";
import { Navigate, useParams } from "react-router-dom";
import SavePreagendamientoSoportePymes from "../shared/componente/save_preagendamiento_sp/SavePreagendamientoSoportePymes";
import { useFetchGetPreagendamientoPymesById } from "@/shared/actions/erp/operaciones/preagendamiento/preagendamiento_pymes.actions";

export default function CreateAgendamientoSoportePymesPage() {

  useCheckPermissions(PermissionsEnum.api_change_preagendamiento);
  const returnUrlAgendamientosPyLPage =
    ROUTER_PATHS.soportePymes.preagendamientoNav;
  const { id } = useParams();
  const { data, isLoading, isRefetching } = useFetchGetPreagendamientoPymesById(id!);

  useLoaders(isLoading);

  useEffect(() => {
    if (isLoading || isRefetching) return;

    /* if (
      !!data &&
      data?.data?.estado_preagendamiento !==
      EstadosPreagendamientoEnumChoice.EN_ESPERA &&
      data?.data?.estado_preagendamiento !==
      EstadosPreagendamientoEnumChoice.EN_PAUSA
    ) {
      setAlert(
        true,
        "La solicitud no se encuentra en estado correcto",
        AlertSeverityEnum.error
      );
    } */
  }, [data, isLoading, isRefetching]);

  if (isLoading) return null;

  if (!data?.data?.id_preagendamiento_pymes)
    return <Navigate to={returnUrlAgendamientosPyLPage} />;

  return (
    <SavePreagendamientoSoportePymes
      title="Agendamiento Soporte Pymes"
      preagendamiento={data.data}
    />
  )

}